import { render, staticRenderFns } from "./Example.vue?vue&type=template&id=7334ebfd&scoped=true"
import script from "./Example.vue?vue&type=script&lang=ts"
export * from "./Example.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7334ebfd",
  null
  
)

export default component.exports